import { render, staticRenderFns } from "./ProAndCer.vue?vue&type=template&id=fe67e66e&scoped=true"
import script from "./ProAndCer.vue?vue&type=script&lang=js"
export * from "./ProAndCer.vue?vue&type=script&lang=js"
import style0 from "./ProAndCer.scss?vue&type=style&index=0&id=fe67e66e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe67e66e",
  null
  
)

export default component.exports